// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-D1":"D1_vanlife-roadtrips-D1__q1mx_"};